import { analytics } from '../Firebase';
import { logEvent } from 'firebase/analytics';
import { omit } from 'lodash';
export function withoutKey(event) {
    return omit(event, ['key']);
}
export function sendEventToFirebase(event) {
    logEvent(analytics, event.key, withoutKey(event));
}
